module.exports = "/_next/static/images/logo-dark-5445f3feafbdbba4da7ea1187b8d476f.png";